import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'keys' })
export class KeysPipe implements PipeTransform
{
    transform(value:any, args:string[]): any {
        let keys:any[] = [];
        for (let key in value) {
            keys.push({key: key, value: value[key]});
        }
        return keys;
    }
}